import React from "react";
import classNames from "classnames/bind";
import styles from "./Grid.module.scss";
import { RowProps } from "./types";

const cx = classNames.bind(styles);

const Row = ({ children }: RowProps) => {
  return <div className={cx("row")}>{children}</div>;
};

export default Row;
